<template>
	<sf-data-table
		ref="msgTable"
		paging
		height="500px"
		:pageUnit="10"
		:totalSize="popup.groups.totalSize"
		:columns="columns"
		:currentPage="popup.groups.currentPage"
		:rows="dicMsgManagements"
		:span-method="objectSpanMethod"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MenuManagement/store/helpers';
export default {
	data() {
		return {
			currentTableData: null,
			selectedRow: null,
			rowSpanCount: 0
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000337'),
					prop: 'msgKey',
					minWidth: '180px',
					clickEvent: this.selectMsgKey,
					highlight: true,
					sortable: false,
					edit: true
				},
				{
					label: this.getMessage_('SWCC000341'),
					prop: 'msgLoc',
					minWidth: '130px',
					type: 'select',
					options: this.gridMsgLocs,
					edit: false,
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000340'),
					prop: 'msgType',
					minWidth: '130px',
					type: 'select',
					options: this.gridMsgTypes,
					edit: false,
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000339'),
					prop: 'msgLangDesc',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000338'),
					prop: 'msgText',
					minWidth: '300px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000004'),
					prop: 'regDt',
					minWidth: '300px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000005'),
					prop: 'regId',
					minWidth: '150px',
					sortable: false
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			this.$emit('reload', currentPageVal, pageUnitVal);
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			this.currentTableData = this.$refs.msgTable.getTable().tableData;
			let rowSpanKey = ['userSelect', 'tableState', 'msgKey', 'msgType', 'tmpKey', 'msgLoc'];
			if (
				rowSpanKey.findIndex(item => {
					return item == column.property;
				}) >= 0
			) {
				let spanIndex = 0;
				let rowSpanCount = 0;

				let currentKey = this.currentTableData[rowIndex].msgKey;
				let prevKey = rowIndex > 0 ? this.currentTableData[rowIndex - 1].msgKey : null;

				if (prevKey != currentKey) {
					rowSpanCount = 1;
					for (let i = rowIndex + 1; i < this.currentTableData.length; i++) {
						if (currentKey == this.currentTableData[i].msgKey) {
							rowSpanCount++;
						} else {
							break;
						}
					}

					spanIndex = rowIndex;
				}

				if (rowIndex == spanIndex) {
					return {
						rowspan: rowSpanCount,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		},
		selectMsgKey(paramRow) {
			this.$refs.msgTable.getTable().tableData.forEach(row => {
				if (paramRow != null && row.msgKey == paramRow.msgKey) {
					row.userSelect = true;

					paramRow.userSelect = true;
					this.userSelectionChange(row);
					paramRow = null;
				}
			});

			this.$emit('close');
		},
		userSelectionChange(paramRow) {
			this.selectedRow = {};
			this.$refs.msgTable.getTable().tableData.forEach(row => {
				if (row.msgKey != paramRow.msgKey) {
					row.userSelect = false;
				}

				if (row.msgKey == paramRow.msgKey && row.msgLang.toLowerCase() == this.searchParams.msgLang.toLowerCase()) {
					this.selectedRow = row;
				}
			});

			this.$refs.msgTable.multipleSelection = [];
			if (paramRow.userSelect == true) {
				this.$refs.msgTable.multipleSelection.push(paramRow);
			}
		},
		reset() {
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			this.$refs.msgTable.multipleSelection = [];
			this.selectedRow = null;
		}
	},
	created() {
		this.columns[2].options = this.gridScrType;
		this.columns[3].options = this.gridMsgTypes;
	}
};
</script>

<style></style>
